<div data-test="information" class="information col-7">
  @if (!viewMode) {
    <form
      [formGroup]="informationForm"
      [agrConnectForm]="information$"
      (ngSubmit)="save()"
      class="spacing--margin-vertical"
    >
      <mat-form-field class="full-width-field spacing--margin-top">
        <mat-label>{{ 'information.year' | translate }}</mat-label>
        <mat-select
          placeholder="{{ 'information.year' | translate }}"
          formControlName="year"
          data-test="information__year"
        >
          @for (year of years; track year) {
            <mat-option [value]="year">
              {{ year }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (cultivations$ | async; as cultivations) {
        <mat-form-field class="full-width-field">
          <mat-label>{{ 'information.cultivation' | translate }}</mat-label>
          <mat-select
            placeholder="{{ 'information.cultivation' | translate }}"
            formControlName="cultivation"
            [compareWith]="compareCultivationsFn"
            data-test="information__cultivation"
          >
            @for (cultivation of cultivations; track cultivation) {
              <mat-option [value]="cultivation">
                {{ cultivation.cultivation }}
              </mat-option>
            }
          </mat-select>
          @if (informationForm.controls.cultivation.invalid) {
            <mat-error>{{ 'information.error-cultivation' | translate }}</mat-error>
          }
        </mat-form-field>
      }
      @if (grainCertificates$ | async; as grainCertificates) {
        <mat-form-field class="full-width-field">
          <mat-label>{{ 'information.certification' | translate }}</mat-label>
          <mat-select
            placeholder="{{ 'information.certification' | translate }}"
            formControlName="grainCertificate"
            [compareWith]="compareCertificatesFn"
            data-test="information__certificate"
          >
            @for (grainCertificate of grainCertificates; track grainCertificate) {
              <mat-option [value]="grainCertificate">
                {{ grainCertificate.certificate }}
              </mat-option>
            }
          </mat-select>
          @if (informationForm.controls.grainCertificate.invalid) {
            <mat-error>{{ 'information.error-grain-certificate' | translate }}</mat-error>
          }
        </mat-form-field>
      }
      @if (showSkalNumber) {
        <mat-form-field class="full-width-field">
          <mat-label>{{ 'information.skal' | translate }}</mat-label>
          <input
            formControlName="skalNumber"
            matInput
            placeholder=""
            type="number"
            data-test="information__skal-number"
          />
          @if (informationForm.controls.skalNumber.invalid) {
            <mat-error>{{ 'information.error-skal-number' | translate }}</mat-error>
          }
        </mat-form-field>
      }
      @if (showTransitionDate) {
        <mat-form-field class="full-width-field">
          <mat-label>{{ 'information.transition-date' | translate }}</mat-label>
          <input
            formControlName="transitionDate"
            matInput
            [matDatepicker]="mdTransitionDate"
            placeholder=""
            data-test="information__transition-date"
          />
          <mat-datepicker-toggle matSuffix [for]="mdTransitionDate"></mat-datepicker-toggle>
          <mat-datepicker #mdTransitionDate></mat-datepicker>
          @if (informationForm.controls.transitionDate.invalid) {
            <mat-error>{{ 'information.error-transition-date' | translate }}</mat-error>
          }
        </mat-form-field>
      }
      <div class="spacing--margin-vertical spacing--padding-bottom">
        <button mat-flat-button color="primary" type="submit">
          {{ 'save' | translate }}
        </button>
      </div>
    </form>
  }

  @if (hasValidInformation$ | async) {
    @if (!!viewMode && (information$ | async); as information) {
      <div class="spacing--padding-top" data-test="information__values">
        <h3 class="text--h3 text--light">{{ 'information.title' | translate }}</h3>
        <agr-value-row label="{{ 'information.year' | translate }}" data-test="information__year">
          {{ information.year }}
        </agr-value-row>
        <agr-value-row
          label="{{ 'information.cultivation' | translate }}"
          data-test="information__cultivation"
        >
          {{ information.cultivation.cultivation }}
        </agr-value-row>
        <agr-value-row
          label="{{ 'information.certification' | translate }}"
          data-test="information__certificate"
        >
          {{ information.grainCertificate.certificate }}
        </agr-value-row>
        @if (showSkalNumber) {
          <agr-value-row
            label="{{ 'information.skal' | translate }}"
            data-test="information__skal-number"
          >
            {{ information.skalNumber }}
          </agr-value-row>
        }
        @if (showTransitionDate) {
          <agr-value-row
            label="{{ 'information.transition-date' | translate }}"
            data-test="information__transition-date"
          >
            {{ information.transitionDate | agrDate: 'shortDate' }}
          </agr-value-row>
        }
      </div>
    }
  }
</div>
